// The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work.

import React, { useState } from "react";
import Header from "../../component/_elements/Header.tsx";
import { useOutletContext } from "react-router-dom";
import { OutletContextType } from "../../types/GlobalType";
import { useMutation, useQuery } from "@tanstack/react-query";
import { personalController } from "../../_api/controllers/personal.controller.ts";
import { capitalizeFirstLetter } from "../../_services/utils.jsx";
import moment from "moment";
import { login as loginAPI } from "../../_api/auth.js";
import { userController } from "../../_api/controllers/user.controller.ts";
import MyLoader from "../../component/loader/MyLoader.tsx";

const Admin: React.FC = () => {
  const { isDarkMode, setIsDarkMode } = useOutletContext<OutletContextType>();
  const [currentYear, setCurrentYear] = useState("2025 - 2026");
  const [isYearDropdownOpen, setIsYearDropdownOpen] = useState(false);
  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };
  const toggleYearDropdown = () => {
    setIsYearDropdownOpen(!isYearDropdownOpen);
  };
  const [errorMessage, setErrorMessage] = useState("");
  // const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isEditingPersonalInfo, setIsEditingPersonalInfo] = useState(false);

  //fetch all personnel data
  const { data: personnelData } = useQuery({
    queryKey: ["personals"],
    queryFn: personalController.getAll,
  });

  // const personnelDataArr = personnelData?.data || [];

  //get currentuser data id from localstorage
  //get connected user data from localstorage

  const storedUser = JSON.parse(localStorage.getItem("user") || "null");
  const currentUserData = storedUser.userData ? storedUser.userData : null;
  // console.log(storedUser);

  const userId = storedUser ? storedUser.id : null;
  const role = storedUser ? storedUser.role : null;
  const firstName = storedUser ? currentUserData?.nom : null;
  // const secondName = storedUser ? currentUserData.postnom : null;
  const lastName = storedUser ? currentUserData?.prenom : null;
  const email = storedUser ? currentUserData?.email : null;
  const createdAt = storedUser
    ? currentUserData?.created_at || currentUserData?.updated_at
    : null;
  const address = storedUser
    ? `${currentUserData?.avenue}, ${currentUserData?.quartier}, ${currentUserData?.commune}, ${currentUserData?.ville}`
    : null;
  const phone = storedUser ? currentUserData?.telephone : "000-000-0000";
  const initials = storedUser
    ? `${currentUserData?.nom.charAt(0).toUpperCase() || "U"}${
        currentUserData?.prenom.charAt(0).toUpperCase() || "N"
      }`
    : null;

  const [personalInfo, setPersonalInfo] = useState({
    userId,
    firstName,
    lastName,
    email,
    address,
    phone,
    initials,
    createdAt,
  });
  const [editedPersonalInfo, setEditedPersonalInfo] = useState({
    firstName,
    lastName,
    email,
    address,
    phone,
    initials,
    createdAt,
  });
  const [profileModalData, setProfileModalData] = useState({
    firstName,
    lastName,
    email,
    avatar: "",
  });
  // const [selectedAvatar, setSelectedAvatar] = useState<File | null>(null);

  // const openPasswordModal = () => {
  //   setIsPasswordModalOpen(true);
  // };

  const closePasswordModal = () => {
    setIsProfileModalOpen(false);
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setErrorMessage("");
  };

  // const handlePasswordChange = () => {
  //   // console.log("Changement de mot de passe");
  //   closePasswordModal();
  // };

  const openProfileModal = () => {
    setIsProfileModalOpen(true);
    setProfileModalData({
      firstName: personalInfo.firstName,
      lastName: personalInfo.lastName,
      email: personalInfo.email,
      avatar: "",
    });
  };

  // const closePasswordModal = () => {
  //   setIsPasswordModalOpen(false);
  //   setCurrentPassword("");
  //   setNewPassword("");
  //   setConfirmPassword("");
  //   setErrorMessage("");
  // };

  const [notification, setNotification] = useState<any>(null); // { message, type }

  // Fonction pour afficher une notification
  const showNotification = (message: string, type = "success") => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 3000);
  };
  const handleSubmit = () => {
    //verify password change fields
    setErrorMessage("");
    if (!currentPassword || !newPassword || !confirmPassword) {
      setErrorMessage("Veuillez remplir tous les champs.");
      return;
    }

    //verifier si le nouveau mot de passe et la confirmation correspondent
    if (newPassword !== confirmPassword) {
      setErrorMessage("Les nouveaux mots de passe ne correspondent pas.");

      return;
    }

    //verify if new password has at least 6 characters, including letter and special character

    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;
    if (!passwordRegex.test(newPassword)) {
      setErrorMessage(
        "Le nouveau mot de passe doit contenir au moins 6 caractères, dont une majuscule, une minuscule, un chiffre et un caractère spécial.",
      );
      return;
    }
    mutationLogin.mutate({
      email: personalInfo.email,
      password: currentPassword,
    });
  };

  const mutationUpdatePassword = useMutation({
    mutationFn: () =>
      userController.updatePassword(personalInfo.userId, {
        password: newPassword,
      }),

    onSuccess: (data) => {
      // console.log(data);
      showNotification("Mis à jour effectuée avec succès", "success");
      setIsProfileModalOpen(false);
    },

    onError: (err) => {
      // console.log(err);
      showNotification(
        "Une erreur s'est produite, réessayer plus tard",
        "error",
      );
    },
  });

  const mutationLogin = useMutation({
    mutationFn: loginAPI,
    onSuccess: (data) => {
      // console.log(data);
      if (data.token) {
        //after password correct call update password api with new password and current password
        mutationUpdatePassword.mutate();
      } else return showNotification("Mot de passe actuel incorrect.", "error");
    },

    onError: () => {
      showNotification("Mot de passe actuel incorrect.", "error");
      return;
    },
  });

  // const handleProfileModalSave = () => {
  //   setPersonalInfo((prev) => ({
  //     ...prev,
  //     firstName: profileModalData.firstName,
  //     lastName: profileModalData.lastName,
  //     email: profileModalData.email,
  //   }));
  //   console.log("Profil sauvegardé:", profileModalData);
  //   closeProfileModal();
  // };

  // const handleEditPersonalInfo = () => {
  //   setIsEditingPersonalInfo(true);
  //   setEditedPersonalInfo({ ...personalInfo });
  // };

  // const handleSavePersonalInfo = () => {
  //   setPersonalInfo({ ...editedPersonalInfo });
  //   setIsEditingPersonalInfo(false);
  // };

  // const handleCancelEditPersonalInfo = () => {
  //   setEditedPersonalInfo({ ...personalInfo });
  //   setIsEditingPersonalInfo(false);
  // };

  const handlePersonalInfoChange = (field: string, value: string) => {
    setEditedPersonalInfo((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [showPassword3, setShowPassword3] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const togglePasswordVisibility2 = () => {
    setShowPassword2(!showPassword2);
  };

  const togglePasswordVisibility3 = () => {
    setShowPassword3(!showPassword3);
  };

  // const handleProfileModalChange = (field: string, value: string) => {
  //   setProfileModalData((prev) => ({
  //     ...prev,
  //     [field]: value,
  //   }));
  // };

  // const handleAvatarChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = event.target.files?.[0];
  //   if (file) {
  //     setSelectedAvatar(file);
  //   }
  // };

  // const recentActivities = [
  //   {
  //     id: 1,
  //     action: "Connexion au système",
  //     timestamp: "2025-01-06 08:30:15",
  //     icon: "fas fa-sign-in-alt",
  //     color: "text-green-600",
  //   },
  //   {
  //     id: 2,
  //     action: "Modification des paramètres utilisateur",
  //     timestamp: "2025-01-05 16:45:22",
  //     icon: "fas fa-cog",
  //     color: "text-blue-600",
  //   },
  //   {
  //     id: 3,
  //     action: "Consultation des rapports",
  //     timestamp: "2025-01-05 14:20:10",
  //     icon: "fas fa-chart-bar",
  //     color: "text-purple-600",
  //   },
  //   {
  //     id: 4,
  //     action: "Gestion des utilisateurs",
  //     timestamp: "2025-01-04 11:15:33",
  //     icon: "fas fa-users",
  //     color: "text-orange-600",
  //   },
  //   {
  //     id: 5,
  //     action: "Sauvegarde des données",
  //     timestamp: "2025-01-04 09:00:00",
  //     icon: "fas fa-database",
  //     color: "text-indigo-600",
  //   },
  // ];

  return (
    <div className="md:ml-60 w-full">
      {/* Header */}
      <Header
        isDarkMode={isDarkMode}
        setIsDarkMode={setIsDarkMode}
        toggleDarkMode={toggleDarkMode}
        currentYear={currentYear}
        isYearDropdownOpen={isYearDropdownOpen}
        toggleYearDropdown={toggleYearDropdown}
        setCurrentYear={setCurrentYear}
        setIsYearDropdownOpen={setIsYearDropdownOpen}
      />

      <MyLoader
        isLoading={mutationLogin.isPending}
        message="Vérification en cours..."
      />
      <MyLoader
        isLoading={mutationUpdatePassword.isPending}
        message="Modification en cours..."
      />
      {/* Main Content */}
      {/* Main Content */}
      <div className="ml-20 md:ml-0 mt-16 p-4 sm:p-5 lg:p-6">
        <div className="mx-auto w-full max-w-7xl">
          {/* ================= PAGE HEADER ================= */}
          <div className="mb-5 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-center gap-3">
              <div
                className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${
                  isDarkMode
                    ? "bg-blue-500/10 text-blue-400"
                    : "bg-blue-50 text-blue-600"
                }`}
              >
                <i className="fas fa-user-circle text-sm" />
              </div>

              <div>
                <h1
                  className={`text-base font-semibold ${
                    isDarkMode ? "text-gray-100" : "text-gray-900"
                  }`}
                >
                  Mon profil
                </h1>

                <p
                  className={`mt-0.5 text-[10px] sm:text-xs ${
                    isDarkMode ? "text-gray-400" : "text-gray-500"
                  }`}
                >
                  Gérez vos informations personnelles et paramètres de compte
                </p>
              </div>
            </div>
          </div>

          {/* ================= PROFILE SUMMARY ================= */}
          <div
            className={`mb-5 overflow-hidden rounded-2xl border ${
              isDarkMode
                ? "border-[#30363D] bg-[#161B22]"
                : "border-gray-200 bg-white shadow-sm"
            }`}
          >
            <div
              className={`h-1 w-full ${
                isDarkMode ? "bg-blue-500/70" : "bg-blue-600"
              }`}
            />

            <div className="flex flex-col gap-4 p-4 sm:flex-row sm:items-center sm:justify-between sm:p-5">
              <div className="flex min-w-0 items-center gap-4">
                {/* Avatar */}
                <div
                  className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-xl border ${
                    isDarkMode
                      ? "border-blue-500/20 bg-blue-500/10"
                      : "border-blue-100 bg-blue-50"
                  }`}
                >
                  <span
                    className={`text-base font-bold ${
                      isDarkMode ? "text-blue-400" : "text-blue-600"
                    }`}
                  >
                    {personalInfo.initials}
                  </span>
                </div>

                {/* Identity */}
                <div className="min-w-0">
                  <div className="flex flex-wrap items-center gap-2">
                    <h2
                      className={`truncate text-sm font-semibold sm:text-base ${
                        isDarkMode ? "text-gray-100" : "text-gray-900"
                      }`}
                    >
                      {capitalizeFirstLetter(profileModalData.firstName)}{" "}
                      {capitalizeFirstLetter(profileModalData.lastName)}
                    </h2>

                    <span
                      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[9px] font-semibold ${
                        isDarkMode
                          ? "bg-blue-500/10 text-blue-400"
                          : "bg-blue-50 text-blue-700"
                      }`}
                    >
                      <i className="fas fa-shield-alt text-[8px]" />
                      {role || "Rôle Inconnu"}
                    </span>
                  </div>

                  <div className="mt-2 flex flex-col gap-1.5 sm:flex-row sm:items-center sm:gap-4">
                    <span className="flex items-center gap-1.5 text-[10px] text-gray-500">
                      <i className="fas fa-envelope text-[9px]" />
                      <span className="truncate">
                        {personalInfo.email || "Email non renseigné"}
                      </span>
                    </span>

                    <span className="flex items-center gap-1.5 text-[10px] text-gray-500">
                      <i className="fas fa-phone text-[9px]" />
                      {personalInfo.phone || "Téléphone non renseigné"}
                    </span>
                  </div>
                </div>
              </div>

              {/* Password action */}
              <button
                onClick={openProfileModal}
                className="flex h-9 shrink-0 items-center justify-center gap-2 rounded-lg bg-blue-600 px-4 text-[11px] font-medium text-white transition hover:bg-blue-700"
              >
                <i className="fas fa-key text-[9px]" />
                Modifier le mot de passe
              </button>
            </div>
          </div>

          {/* ================= INFORMATION GRID ================= */}
          <div className="grid grid-cols-1 gap-5 lg:grid-cols-5">
            {/* ==================================================
          PERSONAL INFORMATION
      ================================================== */}
            <div
              className={`overflow-hidden rounded-2xl border lg:col-span-3 ${
                isDarkMode
                  ? "border-[#30363D] bg-[#161B22]"
                  : "border-gray-200 bg-white shadow-sm"
              }`}
            >
              {/* Card Header */}
              <div
                className={`flex items-center justify-between border-b px-4 py-3.5 sm:px-5 ${
                  isDarkMode ? "border-[#30363D]" : "border-gray-200"
                }`}
              >
                <div className="flex items-center gap-3">
                  <div
                    className={`flex h-8 w-8 items-center justify-center rounded-lg ${
                      isDarkMode
                        ? "bg-blue-500/10 text-blue-400"
                        : "bg-blue-50 text-blue-600"
                    }`}
                  >
                    <i className="fas fa-address-card text-[10px]" />
                  </div>

                  <div>
                    <h3
                      className={`text-xs font-semibold ${
                        isDarkMode ? "text-gray-200" : "text-gray-800"
                      }`}
                    >
                      Informations personnelles
                    </h3>

                    <p className="mt-0.5 text-[8px] text-gray-500">
                      Informations d'identification et coordonnées
                    </p>
                  </div>
                </div>
              </div>

              {/* Card Content */}
              <div className="p-4 sm:p-5">
                <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                  {/* Prénom */}
                  <div
                    className={`rounded-xl border p-3.5 ${
                      isDarkMode
                        ? "border-[#30363D] bg-[#0D1117]"
                        : "border-gray-200 bg-gray-50/60"
                    }`}
                  >
                    <div className="flex items-start gap-3">
                      <div
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
                          isDarkMode
                            ? "bg-[#21262D] text-gray-400"
                            : "bg-white text-gray-500"
                        }`}
                      >
                        <i className="fas fa-user text-[9px]" />
                      </div>

                      <div className="min-w-0 flex-1">
                        <p className="text-[8px] font-medium uppercase tracking-wide text-gray-500">
                          Prénom
                        </p>

                        {!isEditingPersonalInfo ? (
                          <p
                            className={`mt-1 truncate text-[11px] font-medium ${
                              isDarkMode ? "text-gray-200" : "text-gray-800"
                            }`}
                          >
                            {capitalizeFirstLetter(personalInfo.firstName)}
                          </p>
                        ) : (
                          <input
                            type="text"
                            value={editedPersonalInfo.firstName}
                            onChange={(e) =>
                              handlePersonalInfoChange(
                                "firstName",
                                e.target.value,
                              )
                            }
                            className={`mt-1 h-8 w-full rounded-lg border px-2.5 text-[10px] outline-none focus:border-blue-500 ${
                              isDarkMode
                                ? "border-[#30363D] bg-[#161B22] text-white"
                                : "border-gray-200 bg-white"
                            }`}
                          />
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Nom */}
                  <div
                    className={`rounded-xl border p-3.5 ${
                      isDarkMode
                        ? "border-[#30363D] bg-[#0D1117]"
                        : "border-gray-200 bg-gray-50/60"
                    }`}
                  >
                    <div className="flex items-start gap-3">
                      <div
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
                          isDarkMode
                            ? "bg-[#21262D] text-gray-400"
                            : "bg-white text-gray-500"
                        }`}
                      >
                        <i className="fas fa-id-card text-[9px]" />
                      </div>

                      <div className="min-w-0 flex-1">
                        <p className="text-[8px] font-medium uppercase tracking-wide text-gray-500">
                          Nom
                        </p>

                        {!isEditingPersonalInfo ? (
                          <p
                            className={`mt-1 truncate text-[11px] font-medium ${
                              isDarkMode ? "text-gray-200" : "text-gray-800"
                            }`}
                          >
                            {capitalizeFirstLetter(personalInfo.lastName)}
                          </p>
                        ) : (
                          <input
                            type="text"
                            value={editedPersonalInfo.lastName}
                            onChange={(e) =>
                              handlePersonalInfoChange(
                                "lastName",
                                e.target.value,
                              )
                            }
                            className={`mt-1 h-8 w-full rounded-lg border px-2.5 text-[10px] outline-none focus:border-blue-500 ${
                              isDarkMode
                                ? "border-[#30363D] bg-[#161B22] text-white"
                                : "border-gray-200 bg-white"
                            }`}
                          />
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Email */}
                  <div
                    className={`rounded-xl border p-3.5 ${
                      isDarkMode
                        ? "border-[#30363D] bg-[#0D1117]"
                        : "border-gray-200 bg-gray-50/60"
                    }`}
                  >
                    <div className="flex items-start gap-3">
                      <div
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
                          isDarkMode
                            ? "bg-blue-500/10 text-blue-400"
                            : "bg-blue-50 text-blue-600"
                        }`}
                      >
                        <i className="fas fa-envelope text-[9px]" />
                      </div>

                      <div className="min-w-0 flex-1">
                        <p className="text-[8px] font-medium uppercase tracking-wide text-gray-500">
                          Adresse e-mail
                        </p>

                        {!isEditingPersonalInfo ? (
                          <p
                            className={`mt-1 truncate text-[11px] font-medium ${
                              isDarkMode ? "text-gray-200" : "text-gray-800"
                            }`}
                          >
                            {personalInfo.email}
                          </p>
                        ) : (
                          <input
                            type="email"
                            value={editedPersonalInfo.email}
                            onChange={(e) =>
                              handlePersonalInfoChange("email", e.target.value)
                            }
                            className={`mt-1 h-8 w-full rounded-lg border px-2.5 text-[10px] outline-none focus:border-blue-500 ${
                              isDarkMode
                                ? "border-[#30363D] bg-[#161B22] text-white"
                                : "border-gray-200 bg-white"
                            }`}
                          />
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Téléphone */}
                  <div
                    className={`rounded-xl border p-3.5 ${
                      isDarkMode
                        ? "border-[#30363D] bg-[#0D1117]"
                        : "border-gray-200 bg-gray-50/60"
                    }`}
                  >
                    <div className="flex items-start gap-3">
                      <div
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
                          isDarkMode
                            ? "bg-emerald-500/10 text-emerald-400"
                            : "bg-emerald-50 text-emerald-600"
                        }`}
                      >
                        <i className="fas fa-phone text-[9px]" />
                      </div>

                      <div className="min-w-0 flex-1">
                        <p className="text-[8px] font-medium uppercase tracking-wide text-gray-500">
                          Téléphone
                        </p>

                        {!isEditingPersonalInfo ? (
                          <p
                            className={`mt-1 truncate text-[11px] font-medium ${
                              isDarkMode ? "text-gray-200" : "text-gray-800"
                            }`}
                          >
                            {personalInfo.phone}
                          </p>
                        ) : (
                          <input
                            type="tel"
                            value={editedPersonalInfo.phone}
                            onChange={(e) =>
                              handlePersonalInfoChange("phone", e.target.value)
                            }
                            className={`mt-1 h-8 w-full rounded-lg border px-2.5 text-[10px] outline-none focus:border-blue-500 ${
                              isDarkMode
                                ? "border-[#30363D] bg-[#161B22] text-white"
                                : "border-gray-200 bg-white"
                            }`}
                          />
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Adresse */}
                  <div
                    className={`rounded-xl border p-3.5 sm:col-span-2 ${
                      isDarkMode
                        ? "border-[#30363D] bg-[#0D1117]"
                        : "border-gray-200 bg-gray-50/60"
                    }`}
                  >
                    <div className="flex items-start gap-3">
                      <div
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
                          isDarkMode
                            ? "bg-purple-500/10 text-purple-400"
                            : "bg-purple-50 text-purple-600"
                        }`}
                      >
                        <i className="fas fa-map-marker-alt text-[9px]" />
                      </div>

                      <div className="min-w-0 flex-1">
                        <p className="text-[8px] font-medium uppercase tracking-wide text-gray-500">
                          Adresse
                        </p>

                        {!isEditingPersonalInfo ? (
                          <p
                            className={`mt-1 text-[11px] font-medium leading-relaxed ${
                              isDarkMode ? "text-gray-200" : "text-gray-800"
                            }`}
                          >
                            {personalInfo.address}
                          </p>
                        ) : (
                          <textarea
                            rows={2}
                            className={`mt-1 w-full resize-none rounded-lg border px-2.5 py-2 text-[10px] outline-none focus:border-blue-500 ${
                              isDarkMode
                                ? "border-[#30363D] bg-[#161B22] text-white"
                                : "border-gray-200 bg-white"
                            }`}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ==================================================
          PROFESSIONAL INFORMATION
      ================================================== */}
            <div
              className={`overflow-hidden rounded-2xl border lg:col-span-2 ${
                isDarkMode
                  ? "border-[#30363D] bg-[#161B22]"
                  : "border-gray-200 bg-white shadow-sm"
              }`}
            >
              {/* Header */}
              <div
                className={`border-b px-4 py-3.5 sm:px-5 ${
                  isDarkMode ? "border-[#30363D]" : "border-gray-200"
                }`}
              >
                <div className="flex items-center gap-3">
                  <div
                    className={`flex h-8 w-8 items-center justify-center rounded-lg ${
                      isDarkMode
                        ? "bg-purple-500/10 text-purple-400"
                        : "bg-purple-50 text-purple-600"
                    }`}
                  >
                    <i className="fas fa-briefcase text-[10px]" />
                  </div>

                  <div>
                    <h3
                      className={`text-xs font-semibold ${
                        isDarkMode ? "text-gray-200" : "text-gray-800"
                      }`}
                    >
                      Informations professionnelles
                    </h3>

                    <p className="mt-0.5 text-[8px] text-gray-500">
                      Rôle, accès et informations du compte
                    </p>
                  </div>
                </div>
              </div>

              <div className="p-4 sm:p-5">
                <div className="space-y-3">
                  {/* Role */}
                  <div
                    className={`flex items-center gap-3 rounded-xl border p-3 ${
                      isDarkMode
                        ? "border-[#30363D] bg-[#0D1117]"
                        : "border-gray-200 bg-gray-50/60"
                    }`}
                  >
                    <div
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
                        isDarkMode
                          ? "bg-blue-500/10 text-blue-400"
                          : "bg-blue-50 text-blue-600"
                      }`}
                    >
                      <i className="fas fa-user-shield text-[9px]" />
                    </div>

                    <div>
                      <p className="text-[8px] uppercase tracking-wide text-gray-500">
                        Rôle
                      </p>

                      <p
                        className={`mt-0.5 text-[11px] font-medium ${
                          isDarkMode ? "text-gray-200" : "text-gray-800"
                        }`}
                      >
                        {role}
                      </p>
                    </div>
                  </div>

                  {/* Département */}
                  <div
                    className={`flex items-center gap-3 rounded-xl border p-3 ${
                      isDarkMode
                        ? "border-[#30363D] bg-[#0D1117]"
                        : "border-gray-200 bg-gray-50/60"
                    }`}
                  >
                    <div
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
                        isDarkMode
                          ? "bg-amber-500/10 text-amber-400"
                          : "bg-amber-50 text-amber-600"
                      }`}
                    >
                      <i className="fas fa-building text-[9px]" />
                    </div>

                    <div>
                      <p className="text-[8px] uppercase tracking-wide text-gray-500">
                        Département
                      </p>

                      <p
                        className={`mt-0.5 text-[11px] font-medium ${
                          isDarkMode ? "text-gray-200" : "text-gray-800"
                        }`}
                      >
                        Administration Scolaire
                      </p>
                    </div>
                  </div>

                  {/* Date */}
                  <div
                    className={`flex items-center gap-3 rounded-xl border p-3 ${
                      isDarkMode
                        ? "border-[#30363D] bg-[#0D1117]"
                        : "border-gray-200 bg-gray-50/60"
                    }`}
                  >
                    <div
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
                        isDarkMode
                          ? "bg-emerald-500/10 text-emerald-400"
                          : "bg-emerald-50 text-emerald-600"
                      }`}
                    >
                      <i className="fas fa-calendar-check text-[9px]" />
                    </div>

                    <div>
                      <p className="text-[8px] uppercase tracking-wide text-gray-500">
                        Date d'inscription
                      </p>

                      <p
                        className={`mt-0.5 text-[11px] font-medium ${
                          isDarkMode ? "text-gray-200" : "text-gray-800"
                        }`}
                      >
                        {moment(personalInfo.createdAt).format("DD MMMM YYYY")}
                      </p>
                    </div>
                  </div>

                  {/* Permissions */}
                  <div
                    className={`rounded-xl border p-3.5 ${
                      isDarkMode
                        ? "border-[#30363D] bg-[#0D1117]"
                        : "border-gray-200 bg-gray-50/60"
                    }`}
                  >
                    <div className="mb-3 flex items-center gap-2">
                      <div
                        className={`flex h-7 w-7 items-center justify-center rounded-lg ${
                          isDarkMode
                            ? "bg-purple-500/10 text-purple-400"
                            : "bg-purple-50 text-purple-600"
                        }`}
                      >
                        <i className="fas fa-key text-[8px]" />
                      </div>

                      <div>
                        <p
                          className={`text-[10px] font-semibold ${
                            isDarkMode ? "text-gray-300" : "text-gray-700"
                          }`}
                        >
                          Permissions
                        </p>

                        <p className="text-[8px] text-gray-500">
                          Autorisations attribuées à votre compte
                        </p>
                      </div>
                    </div>

                    <div className="flex flex-wrap gap-1.5">
                      {storedUser.permissions.length > 0 &&
                        storedUser.permissions.map(
                          (perm: string, index: number) => {
                            const colors = [
                              isDarkMode
                                ? "bg-emerald-500/10 text-emerald-400 border-emerald-500/20"
                                : "bg-emerald-50 text-emerald-700 border-emerald-100",

                              isDarkMode
                                ? "bg-blue-500/10 text-blue-400 border-blue-500/20"
                                : "bg-blue-50 text-blue-700 border-blue-100",

                              isDarkMode
                                ? "bg-amber-500/10 text-amber-400 border-amber-500/20"
                                : "bg-amber-50 text-amber-700 border-amber-100",

                              isDarkMode
                                ? "bg-purple-500/10 text-purple-400 border-purple-500/20"
                                : "bg-purple-50 text-purple-700 border-purple-100",
                            ];

                            return (
                              <span
                                className={`inline-flex items-center gap-1.5 rounded-md border px-2 py-1 text-[8px] font-medium ${
                                  colors[index % 4]
                                }`}
                                key={index}
                              >
                                <i className="fas fa-check text-[6px]" />
                                {perm}
                              </span>
                            );
                          },
                        )}

                      <span
                        className={`inline-flex items-center gap-1.5 rounded-md border px-2 py-1 text-[8px] font-medium ${
                          isDarkMode
                            ? "border-emerald-500/20 bg-emerald-500/10 text-emerald-400"
                            : "border-emerald-100 bg-emerald-50 text-emerald-700"
                        }`}
                      >
                        <i className="fas fa-check text-[6px]" />
                        Gestion complète
                      </span>

                      <span
                        className={`inline-flex items-center gap-1.5 rounded-md border px-2 py-1 text-[8px] font-medium ${
                          isDarkMode
                            ? "border-blue-500/20 bg-blue-500/10 text-blue-400"
                            : "border-blue-100 bg-blue-50 text-blue-700"
                        }`}
                      >
                        <i className="fas fa-check text-[6px]" />
                        Rapports
                      </span>

                      <span
                        className={`inline-flex items-center gap-1.5 rounded-md border px-2 py-1 text-[8px] font-medium ${
                          isDarkMode
                            ? "border-purple-500/20 bg-purple-500/10 text-purple-400"
                            : "border-purple-100 bg-purple-50 text-purple-700"
                        }`}
                      >
                        <i className="fas fa-check text-[6px]" />
                        Utilisateurs
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Profile Edit Modal */}
      {/* ================= PASSWORD MODAL ================= */}
      {isProfileModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-black/65 backdrop-blur-sm p-4">
          <div
            className={`relative w-full max-w-md overflow-hidden rounded-2xl border shadow-2xl ${
              isDarkMode
                ? "border-[#30363D] bg-[#161B22]"
                : "border-gray-200 bg-white"
            }`}
          >
            {/* Header */}
            <div
              className={`flex items-center justify-between border-b px-5 py-3.5 ${
                isDarkMode ? "border-[#30363D]" : "border-gray-200"
              }`}
            >
              <div className="flex items-center gap-3">
                <div
                  className={`flex h-9 w-9 items-center justify-center rounded-lg ${
                    isDarkMode
                      ? "bg-blue-500/10 text-blue-400"
                      : "bg-blue-50 text-blue-600"
                  }`}
                >
                  <i className="fas fa-lock text-xs" />
                </div>

                <div>
                  <h3
                    className={`text-sm font-semibold ${
                      isDarkMode ? "text-gray-100" : "text-gray-900"
                    }`}
                  >
                    Modifier le mot de passe
                  </h3>

                  <p className="mt-0.5 text-[9px] text-gray-500">
                    Sécurisez l'accès à votre compte
                  </p>
                </div>
              </div>

              <button
                type="button"
                onClick={closePasswordModal}
                className={`flex h-8 w-8 items-center justify-center rounded-lg border transition ${
                  isDarkMode
                    ? "border-[#30363D] text-gray-400 hover:bg-[#21262D]"
                    : "border-gray-200 text-gray-500 hover:bg-gray-100"
                }`}
              >
                <i className="fas fa-times text-[9px]" />
              </button>
            </div>

            {/* Content */}
            <div className="space-y-4 p-5">
              {/* Account */}
              <div
                className={`flex items-center gap-3 rounded-xl border p-3 ${
                  isDarkMode
                    ? "border-blue-500/20 bg-blue-500/[0.05]"
                    : "border-blue-100 bg-blue-50/60"
                }`}
              >
                <div
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
                    isDarkMode
                      ? "bg-blue-500/10 text-blue-400"
                      : "bg-blue-100 text-blue-600"
                  }`}
                >
                  <i className="fas fa-shield-alt text-[9px]" />
                </div>

                <div className="min-w-0">
                  <p
                    className={`text-[10px] font-medium ${
                      isDarkMode ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Sécurité du compte
                  </p>

                  <p className="mt-0.5 truncate text-[8px] text-gray-500">
                    {personalInfo.email}
                  </p>
                </div>
              </div>

              {/* Current password */}
              <div>
                <label
                  className={`mb-1.5 flex items-center gap-2 text-[10px] font-medium ${
                    isDarkMode ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  <i className="fas fa-key text-[8px] text-gray-500" />
                  Ancien mot de passe
                </label>

                <div className="relative">
                  <i className="fas fa-lock absolute left-3 top-1/2 -translate-y-1/2 text-[9px] text-gray-500" />

                  <input
                    type={showPassword ? "text" : "password"}
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    className={`h-10 w-full rounded-lg border pl-9 pr-10 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                      isDarkMode
                        ? "border-[#30363D] bg-[#0D1117] text-white"
                        : "border-gray-200 bg-white"
                    }`}
                    placeholder="****************"
                  />

                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="absolute inset-y-0 right-0 flex w-9 items-center justify-center text-gray-500 transition hover:text-blue-500"
                  >
                    <i
                      className={`fas ${
                        showPassword ? "fa-eye-slash" : "fa-eye"
                      } text-[10px]`}
                    />
                  </button>
                </div>
              </div>

              {/* New password */}
              <div>
                <label
                  className={`mb-1.5 flex items-center gap-2 text-[10px] font-medium ${
                    isDarkMode ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  <i className="fas fa-shield-alt text-[8px] text-gray-500" />
                  Nouveau mot de passe
                </label>

                <div className="relative">
                  <i className="fas fa-lock absolute left-3 top-1/2 -translate-y-1/2 text-[9px] text-gray-500" />

                  <input
                    type={showPassword2 ? "text" : "password"}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    className={`h-10 w-full rounded-lg border pl-9 pr-10 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                      isDarkMode
                        ? "border-[#30363D] bg-[#0D1117] text-white"
                        : "border-gray-200 bg-white"
                    }`}
                    placeholder="****************"
                  />

                  <button
                    type="button"
                    onClick={togglePasswordVisibility2}
                    className="absolute inset-y-0 right-0 flex w-9 items-center justify-center text-gray-500 transition hover:text-blue-500"
                  >
                    <i
                      className={`fas ${
                        showPassword2 ? "fa-eye-slash" : "fa-eye"
                      } text-[10px]`}
                    />
                  </button>
                </div>
              </div>

              {/* Confirm */}
              <div>
                <label
                  className={`mb-1.5 flex items-center gap-2 text-[10px] font-medium ${
                    isDarkMode ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  <i className="fas fa-check-circle text-[8px] text-gray-500" />
                  Répéter le nouveau mot de passe
                </label>

                <div className="relative">
                  <i className="fas fa-lock absolute left-3 top-1/2 -translate-y-1/2 text-[9px] text-gray-500" />

                  <input
                    type={showPassword3 ? "text" : "password"}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className={`h-10 w-full rounded-lg border pl-9 pr-10 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                      isDarkMode
                        ? "border-[#30363D] bg-[#0D1117] text-white"
                        : "border-gray-200 bg-white"
                    }`}
                    placeholder="****************"
                  />

                  <button
                    type="button"
                    onClick={togglePasswordVisibility3}
                    className="absolute inset-y-0 right-0 flex w-9 items-center justify-center text-gray-500 transition hover:text-blue-500"
                  >
                    <i
                      className={`fas ${
                        showPassword3 ? "fa-eye-slash" : "fa-eye"
                      } text-[10px]`}
                    />
                  </button>
                </div>
              </div>

              {/* Error */}
              {errorMessage && (
                <div
                  className={`flex items-start gap-2.5 rounded-xl border p-3 text-[10px] ${
                    isDarkMode
                      ? "border-red-500/20 bg-red-500/[0.06] text-red-400"
                      : "border-red-100 bg-red-50 text-red-600"
                  }`}
                >
                  <i className="fas fa-exclamation-triangle mt-0.5 text-[9px]" />

                  <span className="leading-relaxed">{errorMessage}</span>
                </div>
              )}

              {/* Security helper */}
              <div className="flex items-start gap-2 px-1 text-[8px] leading-relaxed text-gray-500">
                <i className="fas fa-info-circle mt-0.5 text-[8px]" />

                <span>
                  Utilisez un mot de passe contenant une majuscule, une
                  minuscule, un chiffre et un caractère spécial.
                </span>
              </div>
            </div>

            {/* Footer */}
            <div
              className={`flex flex-col-reverse gap-2 border-t px-5 py-3.5 sm:flex-row sm:justify-end ${
                isDarkMode
                  ? "border-[#30363D] bg-[#0D1117]/40"
                  : "border-gray-200 bg-gray-50/70"
              }`}
            >
              <button
                onClick={closePasswordModal}
                className={`flex h-9 items-center justify-center gap-2 rounded-lg border px-4 text-xs font-medium transition ${
                  isDarkMode
                    ? "border-[#30363D] bg-[#161B22] text-gray-300 hover:bg-[#21262D]"
                    : "border-gray-200 bg-white text-gray-600 hover:bg-gray-100"
                }`}
              >
                <i className="fas fa-times text-[9px]" />
                Annuler
              </button>

              <button
                onClick={handleSubmit}
                className="flex h-9 items-center justify-center gap-2 rounded-lg bg-blue-600 px-5 text-xs font-semibold text-white transition hover:bg-blue-700"
              >
                <i className="fas fa-save text-[9px]" />
                Enregistrer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== NOTIFICATION ===== */}
      {notification && (
        <div
          className={`fixed bottom-4 right-4 px-4 py-2 rounded-lg text-white shadow-lg transition-all duration-500 z-[60] ${
            notification.type === "success" ? "bg-green-500" : "bg-red-500"
          }`}
        >
          <span className=" text-xs "> {notification.message}</span>{" "}
        </div>
      )}
    </div>
  );
};

export default Admin;
